import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { buildingStore } from "store/Building/BuildingStore";
import clsx from "clsx";

const CalculationsInProgressIndicator = () => {
  const { t } = useTranslation();
  const filesStatus = buildingStore.filesCalculationStatus ?? [];

  const completed_chunks = filesStatus
    .map((rec) => rec.completed_chunks)
    .reduce((acc, current) => acc + current, 0);

  const total_chunks = filesStatus
    .map((rec) => rec.total_chunks)
    .reduce((acc, current) => acc + current, 0);

  const isOnlyOneFileWithOneChunk =
    filesStatus?.length === 1 && filesStatus?.[0]?.total_chunks === 1;

  function oneChunkIndicator() {
    return (
      <div
        className={clsx(
          "absolute inset-0 bg-gradient-to-r from-transparent",
          "via-indigo-100 via-0% via-indigo-500 via-50% via-indigo-100 via-100% to-transparent animate-gradient"
        )}
      ></div>
    );
  }

  function multipleChunkIndicator() {
    return (
      <div
        className="h-full bg-indigo-500 absolute transition-all duration-500 ease-in-out"
        style={{
          width: `${(Number(completed_chunks) * 100) / Number(total_chunks)}%`,
        }}
      ></div>
    );
  }

  const inProgressFilesCount = filesStatus.filter(
    (rec) => rec.status === "IN_PROGRESS"
  ).length;

  return (
    <div className="h-full w-[220px] ml-3">
      <div className="text-sm pb-1 text-gray-600">
        {filesStatus?.length > 1 ? (
          <span>
            {t(
              inProgressFilesCount === 1
                ? "dashboard.singleFileIsCalculated"
                : "dashboard.multipleFilesAreCalculated",
              {
                in_progress: inProgressFilesCount,
                total: filesStatus.length,
              }
            )}
          </span>
        ) : (
          <span>{t("dashboard.fileIsCalculated")}</span>
        )}
      </div>
      <div className="h-1 relative max-w-xl rounded-full overflow-hidden">
        <div className="w-full h-full bg-indigo-100 absolute"></div>
        {isOnlyOneFileWithOneChunk
          ? oneChunkIndicator()
          : multipleChunkIndicator()}
      </div>
    </div>
  );
};

export default observer(CalculationsInProgressIndicator);
